import { Routes } from 'config/routes';
import { PermissionsEnum, UserRole } from 'gql/types';
import { RouteType } from 'modules/auth/enums';
import { IModule } from 'modules/common/interfaces';
import { INTERNAL_TEAM_ROLES } from 'modules/user/constants';

import DonationDashboardPage from './pages/DonationDashboardPage';
import DonorDashboardPage from './pages/DonorDashboardPage';
import OperationsDashboardPage from './pages/OperationsDashboardPage';
import OwnerDashboardPage from './pages/OwnerDashboardPage';
import PhlebotomistDashboardPage from './pages/PhlebotomistDashboardPage';
import RecruiterDashboardPage from './pages/RecruiterDashboardPage';

// Phlebotomist dashboard roles:
// - Admin / MedicalDirector / DVM: Full access (admin view), can select any phlebotomist
// - TeamLead: Office-scoped view, can select phlebotomists at same office
// - Phlebotomist: Own stats only
const PHLEBOTOMIST_DASHBOARD_ROLES = [
  UserRole.Admin,
  UserRole.MedicalDirector,
  UserRole.Dvm,
  UserRole.TeamLead,
  UserRole.Phlebotomist,
  UserRole.Operations,
];

const OPERATIONS_DASHBOARD_ROLES = [
  UserRole.Admin,
  UserRole.MedicalDirector,
  UserRole.Dvm,
  UserRole.TeamLead,
  UserRole.Phlebotomist,
  UserRole.RegionalUser,
  UserRole.CanineHandler,
  UserRole.Operations,
];

const RECRUITER_DASHBOARD_ROLES = [
  UserRole.Admin,
  UserRole.MedicalDirector,
  UserRole.Dvm,
  UserRole.TeamLead,
  UserRole.RegionalUser,
  UserRole.Operations,
];

const dashboardModule: IModule = {
  routes: [
    {
      path: Routes.Dashboards,
      Component: PhlebotomistDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: PHLEBOTOMIST_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsPhlebotomist,
      Component: PhlebotomistDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: PHLEBOTOMIST_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsRecruiter,
      Component: RecruiterDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: RECRUITER_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsRecruiterDashboard,
      Component: RecruiterDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: RECRUITER_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsRecruiterDonorDetails,
      Component: RecruiterDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: RECRUITER_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsRecruiterLeaderboard,
      Component: RecruiterDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: RECRUITER_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsOperations,
      Component: OperationsDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: OPERATIONS_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsOperationsOverview,
      Component: OperationsDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: OPERATIONS_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsOperationsPhlebotomist,
      Component: OperationsDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: OPERATIONS_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsOperationsRecruiter,
      Component: OperationsDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: OPERATIONS_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsOperationsHandler,
      Component: OperationsDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: OPERATIONS_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsOperationsDrilldown,
      Component: OperationsDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: OPERATIONS_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsOperationsTrends,
      Component: OperationsDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: OPERATIONS_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsOperationsPaws,
      Component: OperationsDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: OPERATIONS_DASHBOARD_ROLES,
    },
    {
      path: Routes.DashboardsDonors,
      Component: DonorDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: INTERNAL_TEAM_ROLES,
    },
    {
      path: Routes.DashboardsDonations,
      Component: DonationDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: INTERNAL_TEAM_ROLES,
    },
    {
      path: Routes.DashboardsOwners,
      Component: OwnerDashboardPage,
      type: RouteType.Auth,
      permissions: [PermissionsEnum.ViewReports],
      roles: INTERNAL_TEAM_ROLES,
    },
  ],
};

export default dashboardModule;
